import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  CameraService,
  NodeItem,
  StateService,
  ToolService,
} from '../../public-api';
import { ModalController } from '@ionic/angular';
import { UploadItem } from '../models/upload-item';
import { UploadDocumentRequest } from '../models/upload-document-reqest';

@Component({
  selector: 'lib-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss'],
  standalone: false,
})
export class UploadComponent implements OnInit {
  files: UploadItem[] = [];
  errors: string[] = [];

  @Input()
  autoUpload: boolean;
  @Input()
  machineId: string;
  @Input()
  isProfilePicture: boolean;
  @Input()
  displayName: string;
  @Input()
  constructionDayReportId: string;
  @Output()
  filesChanged: EventEmitter<UploadDocumentRequest[]> = new EventEmitter<
    UploadDocumentRequest[]
  >();
  uniqueId: string;
  @Output()
  uniqueIdChanged: EventEmitter<string> = new EventEmitter<string>();

  constructor(
    public state: StateService,
    public cameraService: CameraService,
    public tools: ToolService,
    public modalController: ModalController
  ) {}

  ngOnInit() {
    this.uniqueId = (Math.random() + 1).toString(36).substring(7);
    this.uniqueIdChanged.emit(this.uniqueId);
  }

  fileInput(files: FileList) {
    this.displayName = this.displayName;
    this.files = [];
    if (!files) return;

    Array.from(files).forEach((file) => {
      const splittedName = file.name.split('.');
      const fileType =
        '.' + splittedName[splittedName.length - 1].toLowerCase();

      const item: UploadItem = {
        file,
        blob: undefined,
        displayName: file.name.substring(0, file.name.lastIndexOf('.')),
        fileType,
      };

      if (!this.state.supportedFileTypes.includes(fileType)) {
        this.errors.push(
          `Der Dateityp ${fileType} von ${item.file.name} wird nicht unterstützt (Unterstützt werden ${this.state.supportedFileTypes}))`
        );
      } else if (file.size / 1000 / 1000 < 100) {
        this.files.push(item);
      } else {
        this.errors.push(
          `${item.file.name} überschreitet 100MB Limit (${Math.floor(
            file.size / 1000 / 1000
          )}MB)`
        );
      }
    });
    this.mapFilesToRequests();
  }

  removeFile(index: number) {
    this.files.splice(index, 1);
    if (this.files.length == 0) {
      this.errors = [];
    }
    this.mapFilesToRequests();
  }

  getFileSize(size: number): string {
    return (size / 1000).toFixed(0);
  }

  mapFilesToRequests() {
    if (this.files.length == 0) {
      this.filesChanged.emit([]);
      return;
    }
    const item = this.files[0];
    if (item.file) {
      this.filesChanged.emit(
        this.files.map((x) => ({
          file: x.file,
          fileName: x.file.name,
          displayName: this.isProfilePicture ? this.displayName : x.displayName,
          sizeInBytes: x.file.size,
          machineId: this.machineId,
          isProfilePicture: this.isProfilePicture,
        }))
      );
    } else if (item.blob) {
      this.filesChanged.emit([
        {
          file: item.blob,
          fileName: new Date().toISOString() + item.fileType,
          displayName: this.isProfilePicture
            ? this.displayName
            : item.displayName,

          sizeInBytes: item.blob.size,
          machineId: this.machineId,
          isProfilePicture: this.isProfilePicture,
        },
      ]);
    }
  }

  async openCamera() {
    const photo = await this.cameraService.getPhoto();
    const blob = await fetch(photo.webPath).then((r) => r.blob());

    const item: UploadItem = {
      blob,
      file: undefined,
      displayName:
        'Foto vom ' +
        new Date().toLocaleDateString('de-DE', this.tools.options),
      fileType: '.png',
    };

    this.files.push(item);
  }
}
